import script from "./CardsChatUser.vue?vue&type=script&setup=true&lang=js"
export * from "./CardsChatUser.vue?vue&type=script&setup=true&lang=js"

import "./CardsChatUser.vue?vue&type=style&index=0&id=451c6264&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451c6264"]])

export default __exports__